
/**
 * ======================================================
 * GET GEOLOCALISATION
 * ======================================================
 *
 * Retourne les coordonnées GPS utilisateur
 * sous forme : [longitude, latitude]
 */

export function getGeolocalisation(options = {}) {
  const settings = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
    ...options,
  };

  return new Promise((resolve, reject) => {
    if (typeof window !== "undefined" && window.isSecureContext === false) {
      const error = new Error("Geolocation requires secure context");
      error.code = "INSECURE_CONTEXT";
      reject(error);
      return;
    }

    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = [
          position.coords.longitude,
          position.coords.latitude,
        ];

        resolve(coords);
      },
      (error) => reject(error),
      settings
    );
  });
}
